import { render, staticRenderFns } from "./serviceCard.vue?vue&type=template&id=153f61d2&scoped=true&"
import script from "./serviceCard.vue?vue&type=script&lang=ts&"
export * from "./serviceCard.vue?vue&type=script&lang=ts&"
import style0 from "./serviceCard.vue?vue&type=style&index=0&id=153f61d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f61d2",
  null
  
)

export default component.exports